import { Card, Switch } from '@mui/material';
import { Column, Row } from 'Components/Grid';

export const CardConfigScan = ({ id, disclaimerMonthlySchedule, mutationMonthlySchedule }) => {
  return (
    <Row>
      <Column xs={12}>
        <Card
          sx={{
            padding: '16px',
            marginBlockStart: '16px',
            boxShadow: 'none',
            border: '1px solid #ccc',
          }}
        >
          <Row className="mb-3">
            <Column>
              <span style={{ fontSize: '20px', color: '#4b90fe' }}>Configuração do Escaneamento</span>
            </Column>
          </Row>
          <Row>
            <Column>
              Realizar escaneamento mensal:
              <Switch
                defaultChecked={disclaimerMonthlySchedule}
                onChange={() => {
                  mutationMonthlySchedule.mutate(id);
                }}
                disabled={mutationMonthlySchedule.isLoading || disclaimerMonthlySchedule}
                sx={{
                  width: '50px',
                  marginLeft: '8px',
                  '.Mui-checked': {
                    transform: 'translateX(29px) !important',
                    width: '20px',
                    height: '20px',
                    padding: '0',
                    top: '8px',
                  },
                  '.MuiSwitch-switchBase:not(.Mui-checked)': {
                    width: '20px',
                    height: '20px',
                    padding: '0',
                    transform: 'translateX(0px) !important',
                    // left: '0px',
                    top: '8px',
                  },
                }}
              />
            </Column>
          </Row>
        </Card>
      </Column>
    </Row>
  );
};
